/**
 * The access token lives in memory for the life of the tab — never in
 * localStorage.
 *
 * localStorage is readable by any script on the origin, so a single XSS (a bad
 * dependency, a markdown render that lets a tag through) hands over a working
 * token that keeps working until it expires. Memory is cleared when the tab
 * closes, and the session is restored on the next load from the httpOnly
 * refresh cookie, which script cannot read at all.
 *
 * Cost: the token is gone on reload, so the app makes one silent refresh call
 * at startup. That is the trade every OAuth SPA guide recommends taking.
 */
let accessToken: string | null = null;

export function getAccessToken(): string | null {
  return accessToken;
}

export function setAccessToken(token: string | null): void {
  accessToken = token;
}

/** Whether there is a session to attach to a request. */
export function hasAccessToken(): boolean {
  return getAccessToken() !== null;
}

export function clearAccessToken(): void {
  accessToken = null;
}
